import clsx from "clsx";
import { FC, forwardRef } from "react";

import SearchableSelectBox from "../SearchableSelectBox";
import Tooltip from "../Tooltip";

type RadioOptionType = {
  id: string;
  label: string;
  tooltip: string;
  value: string;
};

type SelectOptionsType = {
  available?: boolean;
  label: string;
  value: string;
};

type RadioBoxWithSelectProps = {
  onChange: (value: string) => void;
  onSelectChange: (value: string) => void;
  options: RadioOptionType[];
  selectOptions: SelectOptionsType[];
  selectPlaceHolder: string;
  selectValue: string;
  value: string;
};

const RadioBoxWithSelect: FC<RadioBoxWithSelectProps> = forwardRef(
  ({
    onChange,
    onSelectChange,
    options,
    selectOptions,
    selectPlaceHolder,
    selectValue,
    value,
    ...rest
  }) => {
    return (
      <>
        {options.map((radio, index) => {
          const isActive = radio.value === value;
          return (
            <div
              className={clsx(
                "p-4 rounded-lg border border-gray-200 cursor-pointer",
                {
                  "mb-6": options.length && index + 1 < options.length,
                },
              )}
              onClick={() => onChange(radio.value)}
            >
              <div className="flex">
                <div className="flex items-center mr-1 text-xs md:text-sm font-medium text-gray-700">
                  <span
                    className={clsx("h-4 w-4 rounded-full block mr-2", [
                      isActive
                        ? "border-[5px] border-black"
                        : "border border-gray-300",
                    ])}
                  />
                  {radio.label}
                </div>
                <Tooltip text={radio.tooltip} position="right" />
              </div>
              {isActive && (
                <div className="pl-6 mt-4">
                  <SearchableSelectBox
                    options={selectOptions}
                    tooltipText="Enter or select the company that issued this order."
                    selected={selectValue || ""}
                    onChange={(value) => {
                      onSelectChange(value || "");
                    }}
                    onClose={() => {
                      onSelectChange("");
                    }}
                    placeholder={selectPlaceHolder || "Select Order Source"}
                    {...rest}
                  />
                </div>
              )}
            </div>
          );
        })}
      </>
    );
  },
);

export default RadioBoxWithSelect;
